module.exports = __webpack_public_path__ + "img/Partners14.cb65c58c.png";